import axios from "axios";
import type { LaborCostDetailsIn } from "@/pages/human-resources/time-management/endpoints/analysis/inout/LaborCostDetailsIn.ts";
import type { LaborCostSectionOut } from "@/pages/human-resources/time-management/endpoints/analysis/inout/LaborCostSectionOut.ts";

export async function getLaborCostDetails(
  params: LaborCostDetailsIn,
): Promise<LaborCostSectionOut[]> {
  const { data } = await axios.get<LaborCostSectionOut[]>(
    "/api/hr/schedule/analysis/laborcost/details",
    {
      params,
    },
  );
  return data;
}

export const laborCostDetailsQueryKey = {
  all: ["schedule_analysis_labor_cost_details"] as const,
  forSiteAndDate: (params: LaborCostDetailsIn) =>
    [
      ...laborCostDetailsQueryKey.all,
      params.domainId,
      params.siteId,
      params.date,
      params.range,
    ] as const,
};
